import { render } from "./MContainer.vue?vue&type=template&id=5c3dd9fd"
import script from "./MContainer.vue?vue&type=script&lang=js"
export * from "./MContainer.vue?vue&type=script&lang=js"

import "./MContainer.vue?vue&type=style&index=0&id=5c3dd9fd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__